import moment from 'moment'
import { createSelector } from 'reselect'

import { selectContactDetailsColumnPreferencesIsLoaded } from 'ducks/agentPreferences'

import { selectCurrentContactMatrixUserPresence } from 'ducks/chat/selectors/presence'
import { selectSubjectForSubjectId } from './base'
import { selectCurrentContact } from './current'
import { selectSubjectForCategoryType } from '../../customFieldCategories/selectors'
import { selectAllCustomFieldsIsLoaded } from '../../customFields/selectors'

export const selectCustomFieldValueForCustomFieldKeyAndCategoryType = createSelector(
  selectSubjectForCategoryType,
  (state, { customFieldKey }) => customFieldKey,
  (subject, customFieldKey) => {
    if (!subject) return null
    return (
      subject.customFieldValues && subject.customFieldValues[customFieldKey]
    )
  }
)

function getCustomFieldFromSubject(subject, customFieldKey) {
  if (!subject) return null
  return subject.customFieldValues && subject.customFieldValues[customFieldKey]
}
export const selectCustomFieldValueForCustomFieldKeyAndSubjectId = createSelector(
  selectSubjectForSubjectId,
  (state, { customFieldKey }) => customFieldKey,
  getCustomFieldFromSubject
)

export const selectCurrentContactCustomFieldValueForCustomFieldKey = createSelector(
  selectCurrentContact,
  (state, { customFieldKey }) => customFieldKey,
  getCustomFieldFromSubject
)

function formatDate(date) {
  if (!date) return ''
  const asDate = new Date(date)
  const now = new Date()
  let format = 'H:mmA'
  if (
    asDate.getDate() !== now.getDate() &&
    asDate.getDate() !== now.getDate()
  ) {
    if (asDate.getFullYear() === now.getFullYear()) format = `D MMM, ${format}`
    else format = `D MMM 'YY, ${format}`
  }
  return moment(date).format(format)
}

export const selectCurrentContactLastSeenAt = createSelector(
  selectCurrentContact,
  contact => {
    const {
      contact_latest_session: {
        value: { lastPageView: { occurredAt } = {} } = {},
      } = {},
    } =
      contact.customFieldValues || {}
    return formatDate(occurredAt)
  }
)

export const selectCurrentContactLastSeenIpLocation = createSelector(
  selectCurrentContact,
  contact => {
    const {
      contact_ip_address: { value: { city, subdivisions, country } = {} } = {},
    } =
      contact.customFieldValues || {}
    return [city, subdivisions, country].filter(x => !!x).join(', ')
  }
)

export const selectCanPageOnClient = createSelector(
  selectContactDetailsColumnPreferencesIsLoaded,
  selectAllCustomFieldsIsLoaded,
  (agentPreferencesLoaded, customFieldsLoaded) => {
    return customFieldsLoaded && agentPreferencesLoaded
  }
)
export const selectLocalTime = createSelector(selectCurrentContact, contact => {
  const {
    contact_browser_time_zone: {
      value: { content: browserTimeZone } = {},
    } = {},
    contact_timezone: { value: { content: contactTimeZone } = {} } = {},
    company_timezone: { value: { content: companyTimeZone } = {} } = {},
  } =
    contact?.customFieldValues || {}
  const timezone = browserTimeZone || contactTimeZone || companyTimeZone
  const localTime =
    timezone &&
    moment()
      .tz(timezone)
      .format('HH:mm')
  if (!localTime) return null
  return `${localTime} - ${timezone || ''}`
})

export const selectLastSeenAt = createSelector(
  selectCurrentContact,
  selectCurrentContactMatrixUserPresence,
  (contact, status) => {
    const { lastSeenAt } = contact || {}
    const formattedLastSeenAt =
      lastSeenAt && moment(lastSeenAt).format("D MMM 'YY, H:mmA")
    return status === 'online' ? 'Online now' : formattedLastSeenAt || null
  }
)
